import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { ArrowBack, Visibility, VisibilityOff } from "@mui/icons-material";
import Header from "../header/Header";
import Sidebar from "./dashboard/AppSideBar";
import BreadCrumbs from "../../generalComponnets/breadCrumbs/BreadCrumbs";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoIcon from "@mui/icons-material/Info";

import { breadcrumbMap, profilepath } from "../../utils/Constant";
import {
  Avatar,
  Box,
  DialogContent,
  DialogContentText,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  Menu,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  change_client_password_api,
  complete_profile_update_api,
  get_outside_jobs_api,
  reset_pop_up_api_for_clients_candidates,
  sections_inside_source_api,
  sourceListApi,
} from "../../DAL/partner/partners";
import { useIds } from "../../hook/AdminContext";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { getPasswordStrength } from "../menu/PasswirdStrength";
import TextEditor from "../editors/ReactEditor";
import { s3baseUri } from "../../config/config";
import CropPopUp from "../userslistToolbars/CCropPopUp";
import CameraAltIcon from "@mui/icons-material/CameraAltOutlined";
import PersonIcon from "@mui/icons-material/PersonOutline";
import GeneralMuiModal from "../menu/MenuModalMui";

const DashboardLayout = () => {
  const clientTypeLabels = {
    clients: "Client",
    agency_partner: "Agency Partner",
    industry_partner: "Industry Partner",
    industry_suppliers: "Industry Supplier",
  };
  const [currentSidebar, setCurrentSidebar] = useState("main");
  const [crop, setCrop] = useState({
    unit: "%",
    width: 95,
    height: 95,
    x: 2.5,
    y: 2.5,
  });

  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showRequirements, setShowRequirements] = useState(false);
  const [adjustedHeight, setAdjustedHeight] = useState("100vh");

  const [isUpdateing, setIsUpdating] = useState(false);
  const fileInputRef = useRef(null);

  const [file, setFile] = useState(null);

  const [croppedImage, setCroppedImage] = useState(null);

  const [loading, setLoading] = useState(false);
  const [dynamicHeight, setDynamicHeight] = useState("100vh");

  const { pathname } = useLocation();
  const theme = useTheme();
  const [openDelete, setOpenDelete] = useState(true);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();

  const [sourceId, setsourceId] = useState(null);
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [partnersObj, setPartnersObj] = useState({});
  const [imageRef, setImageRef] = useState(null);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const handleViewProfile = () => {
    setInputs((old) => ({ ...old, dialogOpen: true }));
    handleMenuClose();
  };

  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const handleMenuOpen = (event) => {
    setInputs((old) => ({ ...old, anchorEl: event.currentTarget }));
  };
  const makeClientCrop = async (crop) => {
    if (imageRef && crop.width && crop.height) {
      const result = await getCroppedImg(imageRef, crop);

      // Set preview URL for display
      setCroppedImage(result.previewUrl);

      // Set the actual file object in inputs for form submission
      setInputs((prev) => ({ ...prev, image: result.file }));

      console.log("Cropped file object:", result.file);
      console.log("Preview URL:", result.previewUrl);
    }
  };

  const handleCropImage = async () => {
    if (!imageRef) {
      alert("Image not loaded");
      return;
    }

    let finalCrop = crop;

    // Convert percentage crop to pixel crop if needed
    if (crop.unit === "%") {
      finalCrop = {
        unit: "px",
        x: (crop.x / 100) * imageRef.width,
        y: (crop.y / 100) * imageRef.height,
        width: (crop.width / 100) * imageRef.width,
        height: (crop.height / 100) * imageRef.height,
      };
    }

    const result = await getCroppedImg(imageRef, finalCrop);
    setCroppedImage(result.previewUrl); // Preview
    setInputs((prev) => ({ ...prev, image: result.file })); // Save for API
    setCropModalOpen(false);
  };
  const getCroppedImg = (image, crop) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }

        // Create file object for form submission
        const croppedFile = new File([blob], "cropped.jpeg", {
          type: "image/jpeg",
        });

        // Create preview URL
        const previewUrl = window.URL.createObjectURL(blob);

        resolve({ file: croppedFile, previewUrl });
      }, "image/jpeg");
    });
  };
  const onImageLoaded = (e) => {
    console.log("Image loaded for cropping:", e.target);
    setImageRef(e.target); // e.target is the actual img element
  };
  const onCropComplete = async (crop) => {
    await makeClientCrop(crop);
  };
  const fileChangedHandler = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Handle SVG files differently
    if (file.type === "image/svg+xml") {
      const reader = new FileReader();
      reader.onload = () => {
        // Directly set the SVG as preview and file
        setCroppedImage(reader.result);
        setInputs((prev) => ({ ...prev, image: file }));
      };
      reader.readAsDataURL(file);
      return; // Skip the cropping modal for SVG
    }

    // Original handling for other image types
    const reader = new FileReader();
    reader.onload = () => {
      setFile(reader.result);
      setCropModalOpen(true);
    };
    reader.readAsDataURL(file);

    setCrop({
      unit: "%",
      width: 95,
      height: 95,
      x: 2.5,
      y: 2.5,
    });

    setCroppedImage(null);
    setInputs((prev) => ({ ...prev, image: null }));
    e.target.value = "";
  };
  const handleSaveFullImage = () => {
    if (file) {
      // Convert base64 to file object
      fetch(file)
        .then((res) => res.blob())
        .then((blob) => {
          const fullImageFile = new File([blob], "full-image.jpeg", {
            type: "image/jpeg",
          });

          // Set the full image in inputs
          setInputs((prev) => ({ ...prev, image: fullImageFile }));

          // Set preview (use the original file as preview)
          setCroppedImage(file);

          // Close modal
          setCropModalOpen(false);
        });
    }
  };

  const handleMenuClose = () => {
    setInputs((old) => ({ ...old, anchorEl: null }));
  };

  const INITIAL_VALUES = {
    first_name: "",
    email: "",
    anchorEl: null,
    avatar: "",
    dialogOpen: false,
    loading: false,
    last_name: "",
    post_code: "",
    contact_number: "",
    status: true,
    company_name: "",
    sectorChoose: "",
    contact_name: "",
    twitter_link: "",
    youtube: "",
    linkedIn_link: "",
    facebook_link: "",
    instagram_link: "",
    location: "",
    website: "",
    street_address: "",
    state: "",
    city: "",
    country: "",
    about: "",
    image: "",
    password: "",
    confirm_password: "",
    title: "",
    lastName: "",
  };

  const [inputs, setInputs] = useState(INITIAL_VALUES);
  const [selectedClientTypes, setSelectedClientTypes] = useState([]);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    setIds,
    breadCrumb,
    setUserInfo,
    userInfo,
    setSourceSectionIds,
    findId,
  } = useIds();
  const load_more_path = "api/jobs/list?page=0&limit=50";
  console.log(userInfo, "userInfouserInfouserInfouserInfouserInfo");

  const fetchData = async () => {
    const response = await sourceListApi(0, 100, "");
    console.log(userInfo, "infouiinffaoskdajslhunasjkhiu");

    if (response.code === 200) {
      if (response?.user_detail) {
        setUserInfo(response.user_detail);
        localStorage.setItem("user", JSON.stringify(response.user_detail));
      }
      localStorage.setItem("side_bar_data", JSON.stringify(response.source));
      setIds(response.source);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((old) => ({ ...old, [name]: value }));
  };
  const handlePasswordChange = () => {
    // Add your password change logic here
    // Validate passwords match, make API call, etc.
  };

  const handleDelete = async () => {
    setOpenDelete(false);
  };
  const handleBack = () => {
    setShowPasswordFields(false);
    setNewPassword("");
    setOldPassword("");
    setConfirmPassword("");
  };
  const handleChangeType = (value) => {
    setSelectedClientTypes(value);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userInfo?.is_temporary_password === true) {
      if (!inputs.password) {
        enqueueSnackbar("New password is required", { variant: "error" });
        return;
      }

      const passwordErrors = [];
      if (inputs.password.length < 8)
        passwordErrors.push("at least 8 characters");
      if (!/[A-Z]/.test(inputs.password))
        passwordErrors.push("one uppercase letter");
      if (!/[a-z]/.test(inputs.password))
        passwordErrors.push("one lowercase letter");
      if (!/[0-9]/.test(inputs.password)) passwordErrors.push("one number");
      if (!/[^A-Za-z0-9]/.test(inputs.password))
        passwordErrors.push("one special character");

      if (passwordErrors.length > 0) {
        enqueueSnackbar(`Password must contain: ${passwordErrors.join(", ")}`, {
          variant: "error",
        });
        return;
      }

      if (inputs.password !== inputs.confirm_password) {
        enqueueSnackbar("New Password and confirm New Password don't match", {
          variant: "error",
        });
        return;
      }
    }

    // URL validation function
    const validateUrl = (url) => {
      if (url && !/^https?:\/\//i.test(url)) {
        return false; // Invalid URL
      }
      return true; // Valid URL
    };

    // Validate social media URLs if provided (optional fields) - Always run this validation
    const socialMediaFields = [
      { name: "facebook_link", label: "Facebook URL" },
      { name: "linkedIn_link", label: "LinkedIn URL" },
      { name: "instagram_link", label: "Instagram URL" },
      { name: "youtube", label: "YouTube URL" },
      { name: "twitter_link", label: "Twitter URL" },
    ];

    for (const field of socialMediaFields) {
      const value = inputs[field.name]?.trim();

      // Only validate if user has provided a value
      if (value && !validateUrl(value)) {
        enqueueSnackbar(`${field.label} must start with http:// or https://`, {
          variant: "error",
        });
        return;
      }
    }

    if (userInfo?.is_profile_completed === false) {
      const hasNewImage = inputs?.image && typeof inputs.image !== "string";
      const hasOldImage = croppedImage && typeof croppedImage === "string";
      if (!hasNewImage && !hasOldImage) {
        enqueueSnackbar("Profile image is required", { variant: "error" });
        return;
      }

      const requiredFields = [
        { name: "company_name", label: "Company name" },
        { name: "contact_name", label: "Contact name" },
        { name: "contact_number", label: "Contact number" },
        { name: "post_code", label: "Post code" },
        { name: "location", label: "Location" },
        { name: "email", label: "Email" },
        { name: "website", label: "Website" },
        { name: "about", label: "About Yourself" },
      ];

      for (const field of requiredFields) {
        const value = inputs[field.name]?.trim();

        // Required check
        if (!value) {
          enqueueSnackbar(`${field.label} is required`, { variant: "error" });
          return;
        }

        if (["website"].includes(field.name)) {
          if (!validateUrl(value)) {
            enqueueSnackbar(
              `${field.label} must start with http:// or https://`,
              { variant: "error" }
            );
            return;
          }
        }
      }

      if (userInfo?.client_type?.includes("clients") && !inputs.sectorChoose) {
        enqueueSnackbar("Sector selection is required", { variant: "error" });
        return;
      }
    }

    setInputs((prev) => ({ ...prev, loading: true }));
    setIsUpdating(true);
    const hasNewImage = inputs?.image && typeof inputs.image !== "string";
    const hasOldImage = croppedImage && typeof croppedImage === "string";
    if (!hasNewImage && !hasOldImage) {
      enqueueSnackbar("Profile image is required", { variant: "error" });
      return;
    }

    try {
      const formData = new FormData();
      if (userInfo?.is_temporary_password === true) {
        formData.append("password", inputs.password);
        formData.append("confirm_password", inputs.confirm_password);
      }

      formData.append("company_name", inputs.company_name);
      formData.append("location", inputs.location);
      formData.append("email", inputs.email);
      formData.append("contact_number", inputs.contact_number);
      formData.append("post_code", inputs.post_code);
      formData.append("linkedin", inputs.linkedIn_link);
      formData.append("youtube", inputs.youtube);
      formData.append("twitter", inputs.twitter_link);
      formData.append("instagram", inputs.instagram_link);
      formData.append("facebook", inputs.facebook_link);
      formData.append("contact_name", inputs.contact_name);
      formData.append("website", inputs.website);
      formData.append("about", inputs.about);
      formData.append("sector", inputs.sectorChoose);

      if (hasNewImage) {
        formData.append("image", inputs.image);
      } else if (hasOldImage) {
        const response = await fetch(croppedImage);
        const blob = await response.blob();
        const urlParts = croppedImage.split("/");
        const filename = urlParts[urlParts.length - 1] || "profile_image.jpg";
        const file = new File([blob], filename, { type: blob.type });
        formData.append("image", file);
      }
      const response = await complete_profile_update_api(formData);

      if (response.code === 200) {
        const data = { ...response.data };

        setInputs((old) => ({ ...old, ...data }));
        const updatedUser = {
          ...response.data,
          is_temporary_password: false,
          is_profile_completed: true,
        };

        localStorage.setItem("user", JSON.stringify(updatedUser));
        setUserInfo(updatedUser);
        setOpenDelete(false);
        setIsUpdating(false);

        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      } else {
        enqueueSnackbar(response.message, { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("An error occurred while updating", { variant: "error" });
    } finally {
      setInputs((prev) => ({ ...prev, loading: false }));
      setIsUpdating(false);
    }
  };
  const handleSubmitCandidate = async () => {
    if (userInfo?.is_temporary_password === true) {
      if (!inputs.password) {
        enqueueSnackbar("New password is required", { variant: "error" });
        return;
      }

      const passwordErrors = [];
      if (inputs.password.length < 8)
        passwordErrors.push("at least 8 characters");
      if (!/[A-Z]/.test(inputs.password))
        passwordErrors.push("one uppercase letter");
      if (!/[a-z]/.test(inputs.password))
        passwordErrors.push("one lowercase letter");
      if (!/[0-9]/.test(inputs.password)) passwordErrors.push("one number");
      if (!/[^A-Za-z0-9]/.test(inputs.password))
        passwordErrors.push("one special character");

      if (passwordErrors.length > 0) {
        enqueueSnackbar(`Password must contain: ${passwordErrors.join(", ")}`, {
          variant: "error",
        });
        return;
      }

      if (inputs.password !== inputs.confirm_password) {
        enqueueSnackbar("New Password and confirm New Password don't match", {
          variant: "error",
        });
        return;
      }
    }
    setInputs((prev) => ({ ...prev, loading: true }));
    const data = {
      email: userInfo?.user_id?.email,
      password: inputs.password,
      confirm_password: inputs.confirm_password,
    };
    try {
      const response = await reset_pop_up_api_for_clients_candidates(data);
      if (response.code === 200) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
        setUserInfo((prev) => ({
          ...prev,
          is_temporary_password: false,
        }));
        setOpenDelete(false);
        setIsUpdating(false);
      } else {
        enqueueSnackbar(response.message, { variant: "error" });
        // setUserInfo((prev) => ({ ...prev, is_temporary_password: false }));
      }
    } catch (error) {
      enqueueSnackbar("An error occurred while submitting candidate", {
        variant: "error",
      });
    } finally {
      setInputs((prev) => ({ ...prev, loading: false }));
    }
  };
  useEffect(() => {
    console.log(userInfo, "userInfouserInfouserInfouserInfoinininini");
    if (userInfo) {
      setInputs((old) => ({
        ...old,
        ...userInfo,
        instagram_link: userInfo.social_links?.instagram,
        facebook_link: userInfo.social_links?.facebook,
        twitter_link: userInfo.social_links?.twitter,
        linkedIn_link: userInfo.social_links?.linkedin,
        youtube: userInfo.social_links?.youtube,
        sectorChoose: userInfo.sector,
        contact_name: userInfo.contact_name,
        street_address: userInfo?.street,
        post_code: userInfo?.post_code,
        about: userInfo?.about,
        image: userInfo?.profile_image,
        email: userInfo?.user_id?.email,
        title: userInfo?.company_name,
        lastName: userInfo?.location,
        location: userInfo?.location,
        company_name: userInfo?.company_name,
        contact_number: userInfo?.contact_number,
      }));
      setSelectedClientTypes(userInfo.client_type);

      if (userInfo?.profile_image) {
        setCroppedImage(s3baseUri + userInfo.profile_image);
      }
      // setCroppedImage(userInfo?.profile_image);
    }
  }, [userInfo]);
  // console.log(inputs.image, "inputs.image value:");
  // console.log(s3baseUri + inputs.image, "Full image URL:");
  // console.log(croppedImage, "croppedImage value:");
  // console.log(cropModalOpen, "cropModalOpen state:");
  // console.log(userInfo?.type, "User type:");
  const fecthSources = async () => {
    const response = await sections_inside_source_api(0, 100, "");

    if (response.code === 200) {
      // if (response?.user_detail) {
      //   setUserInfo(response.user_detail);
      //   localStorage.setItem("user", JSON.stringify(response.user_detail));
      // }
      localStorage.setItem(
        "section_inside_source_data",
        JSON.stringify(response.feature)
      );
      setSourceSectionIds(response?.feature);
    }
  };
  const handleUpdateImage = () => {
    fileInputRef.current.click();
    handleMenuClose();
  };
  const navigate = useNavigate();

  const breadcrumbsList = (items) => {
    const homeItem = {
      name: (
        <>
          <ArrowBack className="arrow-back" /> Sources
        </>
      ),
      path: "/home",
      active: false,
    };
    const dynamicItems = items?.map((item) => ({
      name: item.name,
      path: item.path,
      active: item.active,
    }));

    return [homeItem, ...dynamicItems];
  };

  const isMobile = useMediaQuery("(max-width:600px)");

  const excludedPaths = ["/home/favourite-jobs", "/home/candidates"];

  const startsWithPaths = [
    // "/home/favourite-jobs/job-detail",
    // "/profile",
    "/hospitality/favourite-jobs",

    "/hospitality/favourite-jobs",
    "/warehouse/favourite-jobs",
    "/fit-out-source/favourite-jobs",
    "/healthcare/favourite-jobs",
    "/office-source/favourite-jobs",
    "/retail-source/favourite-jobs",
    "/construction-source/favourite-jobs",
    "/fit-out-source/favourite-jobs",
    // "/favourite-jobs",
    // "/home/candidates",
    // "/hospitality/candidates",
    // "/warehouse/candidates",
    // "/healthcare/candidates",
    // "/office-source/candidates",
    // "/retail-source/candidates",
    // "/construction-source/candidates",
    // "/fit-out-source/candidates",
    // "/home/feed-job-detail",
    // "/hospitality/feed-job-detail",
    // "/warehouse/feed-job-detail",
    // "/healthcare/feed-job-detail",
    // "/healthcare/feed-job-detail",
    // "/office-source/feed-job-detail",
    // "/retail-source/feed-job-detail",
    // "/food-source/feed-job-detail",
    // "/construction-source/feed-job-detail",
    // "/fit-out-source/feed-job-detail",
    // "/hospitality/feed-job-detail",
    // "/food-source/candidates",
    "/food-source/live-job-feed/job-candidates-page",
    // "/hospitality/applied-jobs",
    // "/home/applied-jobs",
    // "/warehouse/applied-jobs",
    // "/retail-source/applied-jobs",
    // "/construction-source/applied-jobs",
    // "/food-source/applied-jobs",
    // "/healthcare-source/applied-jobs",
    // "/office-source/applied-jobs",
    // "/fit-out-source/applied-jobs",
  ];
  const handleDialogClose = () => {
    setInputs((old) => ({ ...old, dialogOpen: false }));
  };

  const firstSegment = location.pathname.split("/")[1];
  const isFavouriteJobs = pathname === "/favourite-jobs";
  const isFeedJobDetail = pathname.startsWith(
    `/${firstSegment}/feed-job-detail/`
  );
  const candidates = pathname.startsWith(`/${firstSegment}/candidates/`);
  const showHeader =
    isSmallScreen && (isFavouriteJobs || isFeedJobDetail || candidates);
  const fullScreenHeight = window.screen.height;
  console.log(
    fullScreenHeight,
    "fullScreenHeightfullScreenHeightfullScreenHeight"
  );

  // const showHeader =
  //   pathname === "/favourite-jobs" ||

  const shouldHideSidebar =
    excludedPaths?.includes(pathname) ||
    startsWithPaths?.some((path) => pathname.startsWith(path));

  useEffect(() => {
    fetchData();
    fecthSources();
  }, []);
  useEffect(() => {
    const handleResize = () => {
      const zoomLevel = window.devicePixelRatio;
      const baseHeight = window.innerHeight;

      // Increase height when zoomed out
      if (zoomLevel < 1) {
        const extraSpace = (1 - zoomLevel) * 100;
        setDynamicHeight(`calc(100vh + ${extraSpace}px)`);
      } else {
        setDynamicHeight("100vh");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (
      pathname === "/home" ||
      pathname === "/profile" ||
      pathname.includes("payment-requests") ||
      pathname === "/payment-requests/accepted-request" ||
      pathname.startsWith("/favourite-jobs") ||
      pathname.startsWith("/home/candidates") ||
      pathname.startsWith("/hospitality/candidates") ||
      pathname.startsWith("/warehouse/candidates") ||
      pathname.startsWith("/payment-request-details")
    ) {
      setCurrentSidebar("main");
    } else {
      setCurrentSidebar("new_side_bar");
    }
  }, [pathname]);

  const token = localStorage.getItem("token");

  if (!token) {
    navigate("/login");
  }

  return (
    <>
      <Header />
      <GeneralMuiModal
        open={inputs.dialogOpen}
        setOpen={handleDialogClose}
        componentToPass={
          <>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                className="de-flex text-center justify-cotent-center"
                alt="Profile"
                src={
                  croppedImage ||
                  (inputs.image && typeof inputs.image === "string"
                    ? s3baseUri + inputs.image
                    : "")
                }
                style={{ width: 200, height: 200, margin: "0 auto" }}
              />
            </div>
          </>
        }
      />
      <Box
        className={isSmallScreen ? "" : "container-fluid p-0"}
        sx={{
          display: "flex",
          height: `${dynamicHeight}px`, // Use dynamic height
          // minHeight: "50vh",
          marginTop: isSmallScreen ? "50px" : "",
          maxWidth: isSmallScreen ? "100%" : "1250px",
          zoom: isSmallScreen ? "" : "93%",
          overflow: "auto", // Add scroll if conten
        }}
      >
        {!shouldHideSidebar &&
          !(
            userInfo?.type === 1 &&
            Array.isArray(userInfo?.source) &&
            userInfo?.source.length === 0
          ) && (
            <Box sx={{ width: "260px", flexShrink: 0 }}>
              <Sidebar currentSidebar={currentSidebar} />
            </Box>
          )}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 1,
            paddingLeft: "0px !important",
            width: isSmallScreen
              ? "100%"
              : currentSidebar
              ? `calc(100% - 278px)`
              : "100%",
            minHeight: "100vh",
            marginTop: isSmallScreen ? "" : "70px",
          }}
        >
          {breadCrumb && breadCrumb.length > 0 && (
            <div
              className="container-fluid mt-3"
              style={{
                height: isMobile ? "auto" : "",
              }}
            >
              <BreadCrumbs items={breadcrumbsList(breadCrumb)} />
            </div>
          )}

          {(userInfo?.is_temporary_password === true ||
            userInfo?.is_profile_completed === false) && (
            <Dialog
              open={openDelete}
              onClose={() => {}}
              PaperProps={{
                style: {
                  borderRadius: "8px",
                  width: "95%",
                  maxWidth: "1000px",
                  margin: "16px",
                  animation: "slideIn 0.3s ease-out",
                },
              }}
              BackdropProps={{
                style: {
                  backgroundColor: "rgba(0,0,0,0.5)",
                  backdropFilter: "blur(2px)",
                },
              }}
              disableEscapeKeyDown
            >
              <DialogTitle
                style={{
                  backgroundColor: "#000080",
                  color: "white",
                  padding: "16px 24px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {userInfo?.type === 1
                    ? "Security Alert"
                    : "Complete Your Profile"}
                </span>
              </DialogTitle>

              <DialogContent style={{ paddingTop: "24px" }}>
                <Box display="flex" alignItems="flex-start" mb={3}>
                  <Typography variant="body1">
                    <Box display="flex" alignItems="flex-start">
                      <WarningAmberIcon
                        style={{
                          color: "#FFC107",
                          fontSize: "24px",
                          marginRight: "12px",
                          marginTop: "2px",
                        }}
                      />
                      {userInfo?.is_temporary_password &&
                      userInfo?.is_profile_completed === false ? (
                        <Box>
                          <Typography
                            variant="subtitle1"
                            style={{ fontWeight: 500, marginBottom: "8px" }}
                          >
                            Important Security Notice
                          </Typography>
                          <Typography variant="body1" paragraph>
                            {
                              "Your account is currently using a temporary password. To ensure your account security, please complete your profile information and set a new password."
                            }
                          </Typography>
                        </Box>
                      ) : userInfo?.is_temporary_password ? (
                        <Box>
                          <Typography
                            variant="subtitle1"
                            style={{ fontWeight: 500, marginBottom: "8px" }}
                          >
                            Important Security Notice
                          </Typography>
                          <Typography variant="body1" paragraph>
                            {
                              "For your security, your account is currently using a temporary password. To safeguard your personal information, we strongly recommend that you reset your password now by setting a secure and permanent one."
                            }
                          </Typography>
                        </Box>
                      ) : (
                        <Box display="flex" alignItems="center">
                          {/* <WarningAmberIcon
                            style={{
                              color: "#FFC107",
                              fontSize: "24px",
                              marginRight: "12px",
                              marginTop: "2px",
                            }}
                          /> */}
                          <Typography variant="body1" paragraph>
                            Please review and complete your profile information
                            to continue.
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Typography>
                </Box>
                {/* Show only when temporary password exists */}
                {userInfo?.is_temporary_password === true && (
                  <>
                    {/* Security message block */}

                    {/* Password Update Fields */}
                    {userInfo.type === 2 && (
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          style={{ marginBottom: "16px" }}
                        >
                          Reset Pasword
                        </Typography>
                      </Grid>
                    )}

                    <Box
                      component="form"
                      sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                    >
                      <Grid container spacing={2}>
                        {/* New Password Field with Strength Indicator */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            required
                            name="password"
                            autoCapitalize="off"
                            autoComplete="new-password"
                            label="New Password"
                            type={showNewPassword ? "text" : "password"}
                            value={inputs.password}
                            onChange={handleChange}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() =>
                                      setShowNewPassword(!showNewPassword)
                                    }
                                    edge="end"
                                  >
                                    {showNewPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />

                          {/* Password Strength Indicator - Only under New Password */}
                          {inputs.password && (
                            <Box sx={{ mt: 1 }}>
                              <div style={{ width: "100%", marginBottom: 3 }}>
                                <div
                                  style={{
                                    height: 8,
                                    borderRadius: 4,
                                    background: "#eee",
                                    width: "100%",
                                    overflow: "hidden",
                                    marginBottom: 6,
                                  }}
                                >
                                  <div
                                    style={{
                                      height: "100%",
                                      width: `${
                                        getPasswordStrength(inputs.password)
                                          .percentage
                                      }%`,
                                      background: getPasswordStrength(
                                        inputs.password
                                      ).color,
                                      transition: "width 0.3s, background 0.3s",
                                    }}
                                  ></div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontWeight: 600,
                                      fontSize: 14,
                                      color: getPasswordStrength(
                                        inputs.password
                                      ).color,
                                      textTransform: "capitalize",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    {getPasswordStrength(inputs.password).level}
                                    <span
                                      style={{
                                        marginLeft: 6,
                                        cursor: "pointer",
                                        verticalAlign: "middle",
                                        color: "#1976d2",
                                        display: "inline-flex",
                                        alignItems: "center",
                                      }}
                                      onClick={() =>
                                        setShowRequirements((prev) => !prev)
                                      }
                                      title="Show password requirements"
                                    >
                                      <InfoIcon
                                        style={{
                                          fontSize: 16,
                                          color: "#1976d2",
                                        }}
                                      />
                                    </span>
                                  </span>
                                </div>
                              </div>
                            </Box>
                          )}

                          {/* Password Requirements */}
                          {showRequirements && (
                            <div
                              style={{
                                background: "#f8f9fa",
                                borderRadius: 6,
                                padding: "12px 16px",
                                marginBottom: 8,
                                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                              }}
                            >
                              <strong style={{ fontSize: 14 }}>
                                Password Requirements
                              </strong>
                              <ul style={{ paddingLeft: 18, marginBottom: 0 }}>
                                <li
                                  style={{
                                    color:
                                      inputs.password.length >= 8
                                        ? "green"
                                        : "red",
                                  }}
                                >
                                  At least 8 characters
                                </li>
                                <li
                                  style={{
                                    color: /[A-Z]/.test(inputs.password)
                                      ? "green"
                                      : "red",
                                  }}
                                >
                                  An uppercase letter (A-Z)
                                </li>
                                <li
                                  style={{
                                    color: /[a-z]/.test(inputs.password)
                                      ? "green"
                                      : "red",
                                  }}
                                >
                                  A lowercase letter (a-z)
                                </li>
                                <li
                                  style={{
                                    color: /\d/.test(inputs.password)
                                      ? "green"
                                      : "red",
                                  }}
                                >
                                  A number (0-9)
                                </li>
                                <li
                                  style={{
                                    color:
                                      /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(
                                        inputs.password
                                      )
                                        ? "green"
                                        : "red",
                                  }}
                                >
                                  A special character (!@#$%^&* etc.)
                                </li>
                              </ul>
                            </div>
                          )}
                        </Grid>

                        {/* Confirm Password Field - Standalone without strength indicator */}
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            required
                            name="confirm_password"
                            autoCapitalize="off"
                            autoComplete="new-password"
                            label="Confirm New Password"
                            type={showConfirmPassword ? "text" : "password"}
                            value={inputs.confirm_password}
                            onChange={handleChange}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() =>
                                      setShowConfirmPassword(
                                        !showConfirmPassword
                                      )
                                    }
                                    edge="end"
                                  >
                                    {showConfirmPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </>
                )}

                {/* Show profile fields only when profile is incomplete */}
                {userInfo?.is_profile_completed === false && (
                  <>
                    {/* Profile Form */}
                    <Grid item xs={12} mt={1}>
                      <Typography variant="h6" style={{ marginBottom: "16px" }}>
                        Update Profile Information
                      </Typography>
                    </Grid>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      flexDirection="column"
                    >
                      <Avatar
                        alt="Profile Picture"
                        src={
                          croppedImage ||
                          (inputs.image && typeof inputs.image === "string"
                            ? s3baseUri + inputs.image
                            : "")
                        }
                        sx={{ width: 100, height: 100, mb: 2 }}
                      />

                      <IconButton
                        color="primary"
                        aria-controls="profile-menu"
                        aria-haspopup="true"
                        onClick={handleMenuOpen}
                        sx={{
                          bgcolor: "white",
                          color: "navy",
                          borderRadius: "50%",
                          bottom: "50px",
                          left: "40px",
                          "&:hover": {
                            color: "navy",
                            backgroundColor: "white",
                          },
                        }}
                      >
                        <CameraAltIcon />
                      </IconButton>

                      <Menu
                        id="profile-menu"
                        anchorEl={inputs.anchorEl}
                        open={Boolean(inputs.anchorEl)}
                        onClose={handleMenuClose}
                        anchorOrigin={{
                          vertical: "bottom",
                          horizontal: "left",
                        }}
                        transformOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                      >
                        <MenuItem onClick={handleUpdateImage}>
                          <ListItemIcon>
                            <CameraAltIcon fontSize="small" />
                          </ListItemIcon>
                          Update Image
                        </MenuItem>
                        <MenuItem onClick={handleViewProfile}>
                          <ListItemIcon>
                            <PersonIcon fontSize="small" />
                          </ListItemIcon>
                          View Image
                        </MenuItem>
                      </Menu>
                      <input
                        hidden
                        accept="image/jpeg, image/jpg, image/png, image/webp"
                        type="file"
                        ref={fileInputRef}
                        onChange={fileChangedHandler}
                      />

                      {/* Crop Modal */}
                      <CropPopUp
                        cropModalOpen={cropModalOpen}
                        handleModalClose={() => setCropModalOpen(false)}
                        file={file}
                        crop={crop}
                        setCrop={setCrop}
                        onImageLoaded={onImageLoaded}
                        onCropComplete={onCropComplete}
                        handleCropImage={handleCropImage}
                        handleSaveFullImage={handleSaveFullImage}
                      />
                    </Box>
                    <Box
                      component="form"
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            name="company_name"
                            label="Company Name"
                            value={inputs.company_name}
                            onChange={handleChange}
                            required
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            name="contact_number"
                            label="Contact Number"
                            value={inputs.contact_number}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            name="contact_name"
                            label="Contact Name"
                            value={inputs.contact_name}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            name="post_code"
                            label="Post Code"
                            value={inputs.post_code}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            required
                            name="email"
                            label="Email"
                            value={inputs.email}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            name="location"
                            label="Location"
                            value={inputs.location}
                            onChange={handleChange}
                            required
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            required
                            name="website"
                            label="Website"
                            value={inputs.website}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            // required
                            fullWidth
                            name="facebook_link"
                            label="Facebook URL"
                            value={inputs.facebook_link}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            // required
                            fullWidth
                            name="linkedIn_link"
                            label="LinkedIn URL"
                            value={inputs.linkedIn_link}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            // required
                            fullWidth
                            name="instagram_link"
                            label="Instagram URL"
                            value={inputs.instagram_link}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            // required
                            fullWidth
                            name="youtube"
                            label="YouTube URL"
                            value={inputs.youtube}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            // required
                            fullWidth
                            name="twitter_link"
                            label="Twitter URL"
                            value={inputs.twitter_link}
                            onChange={handleChange}
                          />
                        </Grid>
                        {userInfo?.client_type?.includes("clients") && (
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth required>
                              <InputLabel id="demo-simple-select-label">
                                Choose Sector
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                name="sectorChoose"
                                value={inputs.sectorChoose}
                                label="Choose Sector"
                                onChange={handleChange}
                              >
                                <MenuItem value={"Hotel"}>Hotel</MenuItem>
                                <MenuItem value={"Pub"}>Pub</MenuItem>
                                <MenuItem value={"Restaurant"}>
                                  Restaurant
                                </MenuItem>
                                <MenuItem value={"Cafe"}>Cafe</MenuItem>
                                <MenuItem value={"Contract Catering"}>
                                  Contract Catering
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                        <Grid item xs={12} mb={0}>
                          <Typography
                            variant="h6"
                            style={{ marginBottom: 0, fontSize: "18px " }}
                          >
                            About Yourself*
                          </Typography>
                        </Grid>

                        <Grid item xs={12} mt={0}>
                          <TextEditor
                            required
                            inputs={inputs}
                            setInputs={setInputs}
                            name="about"
                            type="about"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </>
                )}
              </DialogContent>
              <DialogActions
                style={{
                  padding: "16px 24px",
                  gap: "12px",
                  margin: 0,
                }}
              >
                <Button
                  variant="contained"
                  onClick={
                    userInfo?.type === 1 ? handleSubmitCandidate : handleSubmit
                  }
                  disabled={inputs.loading}
                  style={{
                    backgroundColor: "#000080",
                    color: "white",
                    textTransform: "none",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    minWidth: "120px",
                  }}
                >
                  {inputs.loading
                    ? userInfo?.type === 1
                      ? "Resetting..."
                      : "Updating..."
                    : userInfo?.type === 1
                    ? "Reset Password"
                    : "Update Profile"}
                </Button>
              </DialogActions>
            </Dialog>
          )}
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default DashboardLayout;
